import { useEffect, useState, ChangeEvent } from "react";

import toast, { Toaster } from "react-hot-toast";
import ContentLayout from "..//components/ContentLayout";

import "bootstrap/dist/css/bootstrap.min.css";
import common from "..//utils/common";

import "bootstrap/dist/css/bootstrap.css";
import "./page.css";
import TrashRecordGrid from "../components/Trash/TrashRecordGrid";
import TrashCalendarGrid from "../components/Trash/TrashCalendarGrid";
import TrashPlaceGrid from "../components/Trash/TrashPlaceGrid";
import { TrashGridType } from "../class/frontend.schema";
import { useI18n } from "../i18n";

const Title = () => {
  const { t } = useI18n();
  const title = t("nav.trash") + " - " + t("meta.appName");
  return (
    <>
      <title>{title}</title>
    </>
  );
};
const Content = () => {
  const [recordType, setRecordType] = useState<TrashGridType>("record");
  return (
    <>
      {recordType && recordType === "record" && (
        <TrashRecordGrid
          toast={toast}
          recordType={recordType}
          setRecordTypeFunc={setRecordType}
        />
      )}
      {recordType && recordType === "calendar" && (
        <TrashCalendarGrid
          toast={toast}
          recordType={recordType}
          setRecordTypeFunc={setRecordType}
        />
      )}
      {recordType && recordType === "place" && (
        <TrashPlaceGrid
          toast={toast}
          recordType={recordType}
          setRecordTypeFunc={setRecordType}
        />
      )}
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          className: "",
          style: common.toasterStyle,
        }}
      />
    </>
  );
};
const Trash = () => {
  return (
    <ContentLayout
      isFluid={true}
      maxWidth="80vw"
      header={<Title />}
      content={<Content />}
    />
  );
};
export default Trash;
